import { render, staticRenderFns } from "./SetPhoto.vue?vue&type=template&id=77ea965b&scoped=true&"
import script from "./SetPhoto.vue?vue&type=script&lang=js&"
export * from "./SetPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SetPhoto.vue?vue&type=style&index=0&id=77ea965b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea965b",
  null
  
)

export default component.exports